<template>
    <div class="com-codics-hbb-order-admin-custom-body">
        <div class="com-codics-hbb-order-admin-custom-bar-content">
            <el-select class="com-codics-hbb-order-admin-custom-bar-input" v-model="userId" clearable filterable remote
                reserve-keyword placeholder="请选择销售" :remote-method="queryUsersFuc" :loading="loading"
                @change="listCusInfo2Fuc">
                <el-option v-for="(item, index) in userData" :key="index" :label="`${item.nickname}(${item.account})`"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-input class="com-codics-hbb-order-admin-user-bar-input" v-model="searchTxt" style="margin-left: 15px;"
                placeholder="请输入客户信息/邮箱/电话..." clearable @change="listCusInfo2Fuc">
            </el-input>
            <!-- <MyButton style="float: left;margin-left: 15px;padding:0 15px;"
                @click.native="nowSearchTxt = searchTxt; listCusInfo2Fuc();">&#xe86e;
            </MyButton> -->
            <MyButton style="float: right;" @click.native="jumpToPage('添加客户', {}, {})">&#xe632; 添加客户</MyButton>
        </div>
        <div class="com-codics-hbb-order-admin-custom-bar-content com-codics-hbb-order-admin-custom-bar-content2"
            style="margin-top: 10px;margin-bottom: 50px;">
            <!-- 客户卡片列表 -->
            <div v-for="(customer, index) in tableData" :key="index" class="com-aonaer-cusinfo-cus-card-customer-card"
                :data-rating="['A级客户', 'B级客户', 'C级客户', 'D级客户', 'E级客户'][customer.rating || 0]"
                @click="jumpToPage('客户详情', { id: customer.id }, {})">
                <div class="com-aonaer-cusinfo-cus-card-card-header">
                    <div class="com-aonaer-cusinfo-cus-card-avatar">
                        {{ getFirstTwoCharsUppercase(customer.name) }}
                    </div>
                    <div class="com-aonaer-cusinfo-cus-card-customer-info">
                        <h3>{{ customer.name }}</h3>
                        <div class="com-aonaer-cusinfo-cus-card-company">
                            {{ customer.com }}
                        </div>
                    </div>
                </div>
                <div class="com-aonaer-cusinfo-cus-card-card-body">
                    <div v-for="(item, idx) in [
                        {
                            label: '来源', value: ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通',
                                '其他来源'][customer.srce] || '-'
                        },
                        { label: '邮箱', value: customer.email || '-' },
                        { label: '电话', value: customer.phone || '-' },
                        { label: '宗教', value: customer?.religion || '-' },
                        { label: '地址', value: customer.area || '-' },
                    ]" :key="idx" class="com-aonaer-cusinfo-cus-card-info-item">
                        <div class="com-aonaer-cusinfo-cus-card-info-label">
                            {{ item.label }}：
                        </div>
                        <div class="com-aonaer-cusinfo-cus-card-info-value">
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div class="com-aonaer-cusinfo-cus-card-card-footer">
                    <div :class="[
                        'com-aonaer-cusinfo-cus-card-status',
                        customer.status === '合作中' ? 'com-aonaer-cusinfo-cus-card-active' : ''
                    ]">
                        {{ customer?.account?.nickname }}
                    </div>
                    <div class="com-aonaer-cusinfo-cus-card-action-buttons">
                        <button class="com-aonaer-cusinfo-cus-card-btn" @click.stop="jumpToShop(customer)">
                            录入询盘
                        </button>
                        <button v-show="customer.account == null" class="com-aonaer-cusinfo-cus-card-btn"
                            @click.stop="nowId2 = customer.id; fpVisible = true;">
                            分配
                        </button>
                        <button class="com-aonaer-cusinfo-cus-card-btn" @click.stop="handleEdit(customer)">
                            编辑
                        </button>
                        <button class="com-aonaer-cusinfo-cus-card-btn com-aonaer-cusinfo-cus-card-primary"
                            @click.stop="jumpToPage('客户详情', { id: customer.id }, {})">
                            详情
                        </button>
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前客户数据吗？" @confirm="deleteCusInfosFuc([customer.id])">
                            <button v-show="customer.member != 0" class="com-aonaer-cusinfo-cus-card-btn"
                                slot="reference" @click.stop="1">
                                删除
                            </button>
                        </el-popconfirm>

                    </div>
                </div>
            </div>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" style="margin-right: calc(100% - 300px);"
                background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="searchTxt == '' ? currentPage : searchPage" :page-sizes="[12, 24, 36, 48]"
                :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <RegisterDialog v-model="registerDialog"></RegisterDialog>
        <RegisterDialog2 v-model="registerDialog2"></RegisterDialog2>
        <MyDialog :visible.sync="addVisible" title="新建客户" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="客户名称" required>
                    <el-input v-model="addForm.name" size="small" placeholder="请输入客户名称" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="联系方式" required>
                    <el-input v-model="addForm.phone" size="small" placeholder="请输入客户联系方式" maxLength="11"
                        style="width:100%;" clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);" label="邮箱">
                    <el-input v-model="addForm.email" size="small" placeholder="请输入客户邮箱" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="所属公司">
                    <el-input v-model="addForm.com" size="small" placeholder="请输入客户所属公司" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户地址" style="width:calc(50% - 7.5px);">
                    <el-input v-model="addForm.area" size="small" placeholder="请输入客户地址信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="所属国家" style="width:calc(50% - 7.5px);margin-left: 15px;">
                    <el-cascader style="width:100%;" :props="{ checkStrictly: true }" size="small" filterable
                        :options="areaOptions" v-model="addForm.country" clearable>
                    </el-cascader>
                </MyFormItem>
                <MyFormItem label="宗教信息" style="width:calc(50% - 7.5px);">
                    <el-input v-model="addForm.religion" size="small" placeholder="请输入客户宗教信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户评级" style="width:calc(50% - 7.5px);margin-left: 15px;" required>
                    <el-select v-model="addForm.rating" style="width:100%;" filterable size="small"
                        placeholder="请选择客户评级">
                        <el-option v-for="(item, index) in ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户']" :key="index"
                            :label="item" :value="index">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="客户来源" style="width:calc(50% - 7.5px);" required>
                    <el-select v-model="addForm.srce" style="width:100%;" filterable size="small" placeholder="请选择客户来源">
                        <el-option
                            v-for="(item, index) in ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通', '其他来源']"
                            :key="index" :label="item" :value="index">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="客户类型" required>
                    <el-select v-model="addForm.pid" style="width:100%;" filterable size="small" placeholder="请选择客户类型">
                        <el-option v-for="(item, index) in [{
                            label: '个人客户',
                            value: 0
                        }, {
                            label: '公海客户',
                            value: 1
                        }]" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain
                    @click="addCusInfoFuc">确认创建</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="addVisible = false;">取消创建</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="fpVisible" title="分配销售" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="负责销售" required>
                    <el-select style="width:100%;" size="small" v-model="nowXs" clearable filterable remote
                        reserve-keyword placeholder="请选择销售" :remote-method="queryUsersFuc" :loading="loading">
                        <el-option v-for="(item, index) in userData" :key="index"
                            :label="`${item.nickname}(${item.account})`" :value="item.id">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="fpXsFuc">确认分配</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="fpVisible = false;">取消分配</el-button>
            </div>
        </MyDialog>
        <el-drawer title="修改客户信息" :visible.sync="cusDrawer" :direction="'btt'" size="100%">
            <button class="com-aonaer-admin-cusinfo-add-custom-field-btn" @click="openCustomFieldModal">
                添加自定义字段
            </button>
            <h2 class="com-aonaer-admin-cusinfo-add-form-group-title">基础信息</h2>
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="客户名称" required>
                    <el-input v-model="updateForm.name" placeholder="请输入客户名称" style="width:100%;" clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="联系方式">
                    <el-input v-model="updateForm.phone" placeholder="请输入客户联系方式" maxLength="11" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);" label="邮箱">
                    <el-input v-model="updateForm.email" placeholder="请输入客户邮箱" style="width:100%;" clearable></el-input>
                </MyFormItem>
                <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" style="margin-top: 20px;">公司信息</h2>
                <MyFormItem style="width:calc(50% - 7.5px);" label="公司名称">
                    <el-input v-model="updateForm.com" placeholder="请输入客户所属公司" style="width:100%;" clearable></el-input>
                </MyFormItem>
                <MyFormItem label="所属国家" style="width:calc(50% - 7.5px);margin-left: 15px;">
                    <el-cascader style="width:100%;" :props="{ checkStrictly: true }" filterable :options="areaOptions"
                        v-model="updateForm.country" clearable>
                    </el-cascader>
                </MyFormItem>
                <MyFormItem label="宗教信息" style="width:calc(50% - 7.5px);">
                    <el-input v-model="updateForm.religion" placeholder="请输入客户宗教信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户地址" style="width:calc(50% - 7.5px);margin-left: 15px;">
                    <el-input v-model="updateForm.area" placeholder="请输入客户地址信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" style="margin-top: 20px;">其他信息</h2>
                <MyFormItem label="客户来源" style="width:calc(50% - 7.5px);" required>
                    <el-select v-model="updateForm.srce" style="width:100%;" filterable placeholder="请选择客户来源">
                        <el-option v-for="(item, index) in [
                            {
                                label: '阿里巴巴',
                                value: 0
                            },
                            {
                                label: '中国制造',
                                value: 1
                            },
                            {
                                label: '独立站',
                                value: 2
                            },
                            {
                                label: '公司展会',
                                value: 3
                            },
                            {
                                label: '集团客户',
                                value: 4
                            },
                            {
                                label: '亚马逊',
                                value: 5
                            },
                            {
                                label: '脸书',
                                value: 6
                            },
                            {
                                label: '广交会',
                                value: 7
                            },
                            {
                                label: '环球资源',
                                value: 8
                            },
                            {
                                label: '社交媒体',
                                value: 9
                            },
                            {
                                label: '速卖通',
                                value: 10
                            },
                            {
                                label: '其他来源',
                                value: 11
                            }
                        ]" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="客户评级" style="width:calc(50% - 7.5px);margin-left: 15px;" required>
                    <el-select v-model="updateForm.rating" style="width:100%;" filterable placeholder="请选择客户评级">
                        <el-option v-for="(item, index) in ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户']" :key="index"
                            :label="item" :value="index">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" v-if="customFields?.length > 0"
                    style="margin-top: 20px;">自定义信息</h2>
                <MyFormItem v-for="(field, index) in customFields" :key="index" style="width:calc(50% - 7.5px);"
                    :style="{ 'margin-left': index % 2 == 0 ? '0px' : '15px' }" :label="field.lb">
                    <el-input v-if="field.type === 0" v-model="field.vl" :placeholder="`请输入${field.vl}`" disabled
                        style="width:100%;" clearable></el-input>
                    <MyUpload v-if="field.type === 1" v-model="field.vl" :limit="10" size="100px" :del="false" disabled>
                    </MyUpload>
                    <el-date-picker v-if="field.type === 2" v-model="field.vl" style="width:100%" type="datetime"
                        disabled placeholder="选择日期时间">
                    </el-date-picker>
                    <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                        icon-color="red" title="确定删除当前信息吗？" @confirm="deleteSxFuc(field)">
                        <div class="com-aonaer-admin-cusinfo-add-form-item-btn iconfont" slot="reference">
                            &#xEC2A;
                        </div>
                    </el-popconfirm>
                </MyFormItem>
            </MyForm>
            <div class="com-aonaer-admin-cusinfo-add-btn-group">
                <button type="button"
                    class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-secondary"
                    @click="cusDrawer = false">取消</button>
                <button type="button" class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-primary"
                    @click="updateCusInfoFuc()">修改</button>
            </div>
        </el-drawer>
        <!-- 自定义字段弹窗 -->
        <div class="com-aonaer-admin-cusinfo-add-modal" style="z-index: 999999999;" v-if="isModalOpen"
            @click="isModalOpen = false;">
            <div class="com-aonaer-admin-cusinfo-add-modal-content" @click.stop>
                <h3 class="com-aonaer-admin-cusinfo-add-modal-title">添加自定义字段</h3>
                <div class="com-aonaer-admin-cusinfo-add-form-item">
                    <label class="com-aonaer-admin-cusinfo-add-form-label">字段名称 <span
                            class="com-aonaer-admin-cusinfo-add-required">*</span></label>
                    <input type="text" class="com-aonaer-admin-cusinfo-add-form-control"
                        style="width: calc(100% - 30px);"
                        :class="{ 'com-aonaer-admin-cusinfo-add-error': !!modalError }" v-model="modalFieldName"
                        placeholder="请输入字段名称">
                    <div class="com-aonaer-admin-cusinfo-add-error-message" v-if="modalError">{{ modalError }}</div>
                </div>
                <div class="com-aonaer-admin-cusinfo-add-form-item">
                    <label class="com-aonaer-admin-cusinfo-add-form-label">数据类型 <span
                            class="com-aonaer-admin-cusinfo-add-required">*</span></label>
                    <select class="com-aonaer-admin-cusinfo-add-form-control" v-model="modalFieldType">
                        <option value="string">字符串（文本输入）</option>
                        <option value="file">文件上传</option>
                        <!-- <option value="number">数字</option> -->
                        <option value="date">日期</option>
                    </select>
                </div>
                <div class="com-aonaer-admin-cusinfo-add-form-item">
                    <label class="com-aonaer-admin-cusinfo-add-form-label">数据类型 <span
                            class="com-aonaer-admin-cusinfo-add-required">*</span></label>
                    <el-input v-if="modalFieldType === 'string'" v-model="modalFieldStringValue"
                        :placeholder="`请输入${modalFieldName}`" style="width:100%;" clearable
                        @input="updateCusInfoSxFuc(field)"></el-input>
                    <MyUpload v-if="modalFieldType === 'file'" v-model="modalFieldFileValue" :limit="10" size="100px">
                    </MyUpload>
                    <el-date-picker v-if="modalFieldType === 'date'" v-model="modalFieldDateValue" style="width:100%"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </div>
                <div class="com-aonaer-admin-cusinfo-add-modal-footer">
                    <button type="button"
                        class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-secondary"
                        @click="isModalOpen = false;">取消</button>
                    <button type="button"
                        class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-primary"
                        @click="confirmAddCustomField">确认添加</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import areaData from '@/../public/data/data2.json';
import dayjs from 'dayjs';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import MyUpload from '@/components/MyUpload';
import RegisterDialog from '@/components/RegisterDialog';
import RegisterDialog2 from '@/components/RegisterDialog2';
import { jumpTo } from '@/utils/myutils';
import { listUsers, deleteUsers, repassUsers, listRole, userRole, listCusInfo2, queryUsers, deleteCusInfo, addCusInfo, fpXs, updateCusInfo, addCusInfoSx, deleteCusInfoSx, updateCusInfoSx } from '@/api';
export default {
    data() {
        return {
            refreshKey: 0,
            nowSid: null,
            modalFieldStringValue: '',
            modalFieldFileValue: [],
            modalFieldDateValue: '',
            isModalOpen: false,
            modalFieldName: '',
            modalFieldType: 'string',
            customFields: [],
            updateForm: {
                pid: 0,
                com: '',
                area: '',
                name: '',
                phone: '',
                email: '',
                country: '',
                religion: '',
                rating: 0,
                srce: 0
            },
            cusDrawer: false,
            nowXs: null,
            fpVisible: false,
            areaOptions: areaData,
            addVisible: false,
            userId: null,
            nowId: null,
            nowId2: null,
            nowRole: [],
            roleDialog: false,
            registerDialog: false,
            registerDialog2: false,
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            userData: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 12,
            searchSize: 12,
            maxSize: 0,
            searchMax: 0,
            loading: false,
            addForm: {
                pid: 0,
                com: '',
                area: '',
                name: '',
                phone: '',
                email: '',
                country: '',
                religion: '',
                rating: 0,
                srce: 0
            }
        }
    },
    components: {
        MyButton,
        MyDialog,
        RegisterDialog,
        RegisterDialog2,
        MyForm,
        MyFormItem,
        MyUpload
    },
    mounted() {
        this.listCusInfo2Fuc();
    },
    methods: {
        async updateCusInfoSxFuc(field) {
            const loading = this.$loading({
                lock: true,
                text: '更新信息中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await updateCusInfoSx({
                id: field.id,
                vl: field.type === 1 ? field.vl.join(',') : field.vl
            });
            loading.close();
            if (data.code == 200) {
                this.$message.success('信息更新成功！');
            } else {
                this.$message.error('信息更新失败！');
            }
        },
        async deleteSxFuc(field) {

            const loading = this.$loading({
                lock: true,
                text: '删除信息中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await deleteCusInfoSx({
                ids: [field.id]
            });
            loading.close();
            if (data.code == 200) {
                this.$message.success('信息删除成功！');
                this.customFields = this.customFields.filter(f => f.id !== field.id);
                this.refreshKey++;
            } else {
                this.$message.error('信息删除失败！');
            }

        },
        async confirmAddCustomField() {
            if (this.modalFieldName == null || this.modalFieldName == '') {
                this.$message.error('请输入信息名称！');
                return;
            }
            if (this.modalFieldType == null || this.modalFieldType == '') {
                this.$message.error('请选择信息类型！');
                return;
            }
            this.isModalOpen = false;
            const loading = this.$loading({
                lock: true,
                text: '添加信息中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await addCusInfoSx({
                sid: this.nowSid,
                lb: this.modalFieldName,
                type: this.modalFieldType == 'string' ? 0 : (this.modalFieldType == 'file' ? 1 : 2),
                vl: this.modalFieldType == 'string' ? this.modalFieldStringValue : (this.modalFieldType == 'file' ? this.modalFieldFileValue.join(',') : this.modalFieldDateValue)
            });
            loading.close();
            console.log(data.code);
            if (data.code == 200) {
                this.$message.success('信息添加成功！');
                if (this.modalFieldType == 'file') {
                    data.data.vl = data.data.vl.split(',') || [];
                }
                this.customFields.push(data.data);
            } else {
                this.$message.error('信息添加失败！');
            }
        },
        // 处理编辑按钮点击事件
        handleEdit(obj) {
            const customer = JSON.parse(JSON.stringify(obj))
            this.updateForm = customer;
            this.updateForm.country = customer.country.split('/') || [];
            this.updateForm.srce = Number(customer.srce || 0);
            this.customFields = customer.sx || [];
            this.nowSid = customer.id;
            this.customFields.forEach(field => {
                if (field.type === 1 && typeof field.vl === 'string') {
                    field.vl = field.vl.split(',') || [];
                }
            });
            this.cusDrawer = true;
        },
        async updateCusInfoFuc() {
            if (this.updateForm.name == null || this.updateForm.name == '') {
                this.$message.error('请输入客户名称！');
                return;
            }
            if (this.updateForm.phone == null || this.updateForm.phone == '' || this.updateForm.phone.length != 11) {
                this.$message.error('客户联系方式未填写或格式不正确！');
                return;
            }
            if (this.updateForm.pid === null || this.updateForm.pid === '') {
                this.$message.error('请选择客户类型！');
                return;
            }
            if (this.updateForm.email !== null && this.updateForm.email !== '') {
                if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.updateForm.email)) {
                    this.$message.error('请输入正确的邮箱格式！');
                    return;
                }
            }
            if (this.updateForm.rating === null || this.updateForm.rating === '') {
                this.$message.error('请选择客户评级！');
                return;
            }
            if (this.updateForm.srce === null || this.updateForm.srce === '') {
                this.$message.error('请选择客户来源！');
                return;
            }
            this.updateForm.country && (this.updateForm.country = this.updateForm.country.join('/'));
            this.updateForm.sx = null;
            const loading = this.$loading({
                lock: true,
                text: '修改中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateCusInfo(this.updateForm);
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户修改成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        // 打开自定义字段弹窗
        openCustomFieldModal() {
            this.isModalOpen = true;
            this.modalFieldName = '';
            this.modalFieldType = 'string';
            this.modalError = '';
        },
        getFirstTwoCharsUppercase(str) {
            // 处理空值、非字符串类型等边界情况
            if (!str || typeof str !== 'string') {
                return '';
            }

            // 1. slice(0, 2) 截取前两个字符（字符串长度不足2时会取全部）
            // 2. toUpperCase() 转换为大写
            const result = str.slice(0, 1).toUpperCase();

            return result;
        },
        jumpToShop(row) {
            window.ceshiProduct = row;
            jumpTo(this, "产品商城", {}, { id: row.id });
        },
        async fpXsFuc() {
            if (this.nowXs === null || this.nowXs === '') {
                this.$message.error('请选择销售！');
                return;
            }
            if (this.nowId2 === null || this.nowId2 === '') {
                this.$message.error('请选择客户！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await fpXs({
                id: this.nowId2,
                uid: this.nowXs
            });
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户分配成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async addCusInfoFuc() {
            if (this.addForm.name == null || this.addForm.name == '') {
                this.$message.error('请输入客户名称！');
                return;
            }
            if (this.addForm.phone == null || this.addForm.phone == '' || this.addForm.phone.length != 11) {
                this.$message.error('客户联系方式未填写或格式不正确！');
                return;
            }
            if (this.addForm.pid === null || this.addForm.pid === '') {
                this.$message.error('请选择客户类型！');
                return;
            }
            if (this.addForm.email !== null && this.addForm.email !== '') {
                if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.addForm.email)) {
                    this.$message.error('请输入正确的邮箱格式！');
                    return;
                }
            }
            if (this.addForm.rating === null || this.addForm.rating === '') {
                this.$message.error('请选择客户评级！');
                return;
            }
            if (this.addForm.srce === null || this.addForm.srce === '') {
                this.$message.error('请选择客户来源！');
                return;
            }
            this.addForm.country && (this.addForm.country = this.addForm.country.join('/'));
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await addCusInfo(this.addForm);
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户创建成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        async listCusInfo2Fuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await listCusInfo2({
                key: this.searchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                uid: this.userId || 0
            });
            loading.close();
            if (data.code == 200) {

                this.tableData = data.data;

                console.log(data.data);

                this.maxSize = data.count;

            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async userRoleFuc() {
            if (this.nowId == null || this.nowId == '') {
                this.$message.error('请先选择要修改的用户！');
                return;
            }
            if (this.nowRole.length == 0) {
                this.$message.error('请选择用户角色！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await userRole({
                id: this.nowId,
                role: this.nowRole[this.nowRole.length - 1]
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async queryUsersFuc(query) {

            if (query === '') {
                this.userData = [];
                return;
            }

            this.loading = true;

            const data = await queryUsers({
                key: query
            });

            this.loading = false;

            if (data.code == 200) {

                this.userData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteCusInfosFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteCusInfo({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listCusInfo2Fuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listCusInfo2Fuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        // searchChange(a) {
        //     if (a == '') {
        //         this.searchPage = 1;
        //         this.searchData = [];
        //         this.searchMax = 0;
        //         this.searchSize = 10;
        //         this.nowSearchTxt = '';
        //     }
        // },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    computed: {
        ...mapState(['userInfo']),
    }
}
</script>

<style>
.com-codics-hbb-order-admin-custom-body {
    height: fit-content;
    max-height: calc(100vh - 50px);
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
}

.com-codics-hbb-order-admin-custom-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-custom-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-custom-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-custom-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.com-aonaer-cusinfo-cus-card-customer-card {
    width: calc(25% - 20px);
    position: relative;
    float: left;
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 20px;
    margin: 10px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    cursor: pointer;
}

.com-aonaer-cusinfo-cus-card-customer-card:hover {
    border-color: #000000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.com-aonaer-cusinfo-cus-card-card-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f3f5;
}

.com-aonaer-cusinfo-cus-card-avatar {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    background-color: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #495057;
    margin-right: 16px;
}

.com-aonaer-cusinfo-cus-card-customer-info h3 {
    font-size: 18px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 4px;
    margin-block-start: unset;
}

.com-aonaer-cusinfo-cus-card-company {
    font-size: 14px;
    color: #6c757d;
}

.com-aonaer-cusinfo-cus-card-card-body {
    margin-bottom: 16px;
}

.com-aonaer-cusinfo-cus-card-info-item {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;
}

.com-aonaer-cusinfo-cus-card-info-label {
    width: 70px;
    color: #6c757d;
    font-weight: 500;
}

.com-aonaer-cusinfo-cus-card-info-value {
    color: #212529;
    flex: 1;
}

.com-aonaer-cusinfo-cus-card-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    border-top: 1px solid #f1f3f5;
}

.com-aonaer-cusinfo-cus-card-status {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 12px;
    background-color: #e9ecef;
    color: #495057;
}

.com-aonaer-cusinfo-cus-card-active {
    background-color: #e6f7ef;
    color: #0f9d58;
}

.com-aonaer-cusinfo-cus-card-action-buttons {
    display: flex;
    gap: 8px;
}

.com-aonaer-cusinfo-cus-card-btn {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    border: 1px solid #dee2e6;
    background: #ffffff;
    color: #495057;
    transition: all 0.2s ease;
}

.com-aonaer-cusinfo-cus-card-btn:hover {
    background-color: #f8f9fa;
    border-color: #adb5bd;
}

.com-aonaer-cusinfo-cus-card-primary {
    background-color: #000000;
    color: #ffffff;
    border-color: #000000;
}

.com-aonaer-cusinfo-cus-card-primary:hover {
    background-color: #212529;
}

.com-aonaer-cusinfo-cus-card-customer-card::before {
    content: attr(data-rating);
    position: absolute;
    top: 30px;
    right: 15px;
    width: fit-content;
    height: 24px;
    padding: 0 12px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    color: #333;
    background-color: #EEE;
    line-height: 24px;
    text-align: center;
}

.com-codics-hbb-order-admin-custom-body .el-drawer {
    padding: 0 20px;
}

.el-picker-panel {
    z-index: 999999999 !important;
}
</style>